import { render, staticRenderFns } from "./ServiceDisplay.vue?vue&type=template&id=9ec76048&"
import script from "./ServiceDisplay.vue?vue&type=script&lang=js&"
export * from "./ServiceDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports